var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"rank",class:_vm.$style.chart},[(_vm.isNoData)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","height":"100%"}},[_c('EmptyContent')],1):_c('div',{ref:"barChart",class:_vm.$style.canvas})])
}
var staticRenderFns = []

export { render, staticRenderFns }